import openSocket from 'socket.io-client';

export const socket = openSocket('http://172.104.213.198:5000');
// export const socket = openSocket('http://localhost:5000');



// WEBPACK FOOTER //
// ./src/socket.js